var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notificationList)?_c('div',_vm._l((_vm.notificationList),function(notification,notificationIndex){return _c('Notification',{key:`notification-${notificationIndex}-${notification.uid}`,attrs:{"message":notification.message,"color":notification.color},on:{"closed":function($event){return _vm.closed(notification)}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }